import { setSessionStorage } from 'src/components/player/src/utils/Utils';
import { useAppStore } from 'src/hooks/useAppStore';
import { BestOffering } from 'src/services/responseTypes/plansMetaDataResponse';
import { mixpanelObject } from 'src/utils/analytics';
import { clearCtaEventsProperty } from 'src/utils/analytics/mixpanel/mixpanelHelper';
import { REDIRECT_URL_TO_CONSUMPTION } from 'src/utils/constants/localStorageConstants';
import { FeatureFlagConstants } from 'src/utils/constants/utilConstants';
import { getFeatureFlagConfig } from 'src/utils/RemoteConfig';

import { getLocalStorage } from '../../../../utils/browserStorageHandler';
import { getsubscribeToPremium } from '../../../../utils/playerHelper';
import { gotoLogin, goToSubscription } from '../playerCallbacks';

type GatingPopupPopupProps = {
  playerRef: any;
  popupProps: any;
};

const GatingPopup = ({ playerRef, popupProps }: GatingPopupPopupProps) => {
  const gatingType = popupProps?.type;
  const { playerConfig = {} } = playerRef || {};
  const { country = 'IN' } = playerConfig || {};
  const { messages = {} } = window.translationsAndConfigs || {};
  const userToken = getLocalStorage('token');
  const { bestOfferingPlan, remoteConfig } = useAppStore();
  const { enabled, payload } = getFeatureFlagConfig(
    remoteConfig,
    FeatureFlagConstants.FEATURE_GATING_MESSAGES
  );
  const messagesFromConfig = enabled ? payload : {};
  const createAccountMessage = () => {
    return (
      <span className={`login-msg subscribemsg_${messages.localeLanguage}`}>
        {messages.AlreadyPremiumMember}
      </span>
    );
  };

  const createLoginButton = () => {
    return (
      <span className="login-link-wrap" onClick={() => loginClick()}>
        <span className="userLogin-link">{messages.Login_Button}</span>
      </span>
    );
  };

  const loginClick = () => {
    setSessionStorage(REDIRECT_URL_TO_CONSUMPTION, window.location.pathname);
    clearCtaEventsProperty(mixpanelObject);
    gotoLogin();
  };

  const buyPlanBtnClick = (playerRef: any) => {
    setSessionStorage(REDIRECT_URL_TO_CONSUMPTION, window.location.pathname);
    const { playerConfig = {} } = playerRef || {};
    const { country = 'IN', tvodObj = null } = playerConfig || {};
    if (
      window.isRevisedSubscriptionJourney &&
      country &&
      country.toLowerCase() === 'in'
    ) {
      clearCtaEventsProperty(mixpanelObject);
    } else {
      goToSubscription({ country, tvodObj });
    }
  };

  return (
    <div className="main-Inner-container gatingContainer">
      {gatingType === 'subscription' ? (
        <div className="subscriptionGatingContainer">
          <div className="gating-title">
            {messagesFromConfig?.FreeWatchEnded_Text_SUBSCRIPTION
              ? messagesFromConfig.FreeWatchEnded_Text_SUBSCRIPTION
              : messages.FreeWatchEnded_Text}
          </div>
          <div className="gating-subtitle">
            {userToken
              ? messagesFromConfig?.BuyPremium_Text || messages.BuyPremium_Text
              : messagesFromConfig?.BuyPremiumOrLogin_Text ||
                messages.BuyPremiumOrLogin_Text}
          </div>
          <div className="section-container main-container-1">
            <div
              className={`register-button subscribemsg_${messages.localeLanguage}`}
              onClick={() => buyPlanBtnClick(playerRef)}>
              <span className="userSubscribe-icon btn-icon" />
              <span>
                {getsubscribeToPremium(
                  country,
                  bestOfferingPlan as BestOffering
                )}
              </span>
            </div>
          </div>

          {(!userToken || userToken.trim() === '') && (
            <div className="section-container main-container-2">
              {createAccountMessage()}
              {createLoginButton()}
            </div>
          )}
        </div>
      ) : (
        <div className="loginGatingContainer">
          <div className="gating-title">
            {messagesFromConfig?.FreeWatchEnded_Text_LOGIN
              ? messagesFromConfig?.FreeWatchEnded_Text_LOGIN
              : messages.FreeWatchEnded_Text}
          </div>
          <div className="gating-subtitle">
            {messagesFromConfig?.LoginOrRegistration_Msg
              ? messagesFromConfig?.LoginOrRegistration_Msg
              : messages.LoginOrRegistration_Msg}
          </div>
          <div
            className={`register-button subscribemsg_${messages.localeLanguage}`}
            onClick={() => loginClick()}>
            <span className="userLogin-icon btn-icon" />
            <span>
              {messagesFromConfig?.FreeWatch_CTA
                ? messagesFromConfig?.FreeWatch_CTA
                : messages.Login_Button}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default GatingPopup;
